export let home_tab = "dlen_d";
export let view_tab = "vzJG4d";
export let message_tab = "NrFgC";
export let insert_tab = "X9_1Lb";
export let format_tab = "VnL4jd";
export let options_tab = "ozkO";
export let notes_tab = "VCft$";
export let format_table_tab = "wjJQie";
export let format_picture_tab = "C4E61d";
export let newMessage_Button = "YKWcZc";
export let newMessage_Button_MLR = "uVnIce";
export let newPost_Button = "x3Zt_";
export let newPostHero_Button = "breDXc";
export let newYammerPost_Button = "UvNRKe";
export let newEMailMessage_Button = "s_8nK";
export let newCalEvent_Button = "fqq_Kc";
export let ignoreEmail_Button = "tUNOXc";
export let stopIgnoringEmail_Button = "KZolPd";
export let blockSender_Button = "TJV50";
export let notJunk_Button = "MyDuCe";
export let archiveEmail_Button = "lsSRKb";
export let sweepEmail_Button = "J9kvxb";
export let replyToEmail_Button = "W$1SF";
export let replyAllToEmail_Button = "fd$tv";
export let replyForwardEmail_Button = "oJvIW";
export let replyForwardEmailAsAttachment_Button = "bxGNuc";
export let replyMeetingToEmail_Button = "nE_X6";
export let replyCopilotMeetingToEmail_Button = "F$mfzb";
export let replyCopilotMeetingToEmail_Button_Tooltip = "BRjs3b";
export let readUnread_Button = "eSe6we";
export let pinUnpin_Button = "cCkT7b";
export let pinUnpin_Button_MLR = "M01Vmb";
export let sendAll_Button = "O4hPpb";
export let updateFolder_Button = "qVPIBb";
export let showSyncProgress_Button = "CyMj8c";
export let cancelSync_Button = "EDNrve";
export let downloadHeaders_Button = "fLP8Ib";
export let move_FlyoutButton = "BqzPEb";
export let move_FlyoutButton_MLR = "xKKlWd";
export let rules_FlyoutButton = "dBgged";
export let createRule_Button = "DkiJjd";
export let manageRules_Button = "nRmsJe";
export let assignPolicy_FlyoutButton = "fjwYUe";
export let assignPolicy_FlyoutButton_MLR = "Zcs5Bd";
export let categorize_FlyoutButton = "ZWYFNc";
export let sendReceiveGroups_Button = "KDUv1d";
export let getMessageExtensions_Button = "EvAiSc";
export let report_Button = "zgnZoc";
export let immersiveReader_Button = "ta3AZb";
export let remindersWindow_Button = "I935sd";
export let printMail_Button = "L8ASvd";
export let snooze_Button = "NgbYWb";
export let undo_Button = "h5j1Yd";
export let block_Button = "kxzoHc";
export let paste_FlyoutButton = "$gE$$d";
export let formatPainter_Button = "HQDsQb";
export let attachSig_Button = "Lqjnbd";
export let encrypt_clearPermissionsButton = "xYn5x";
export let sensitivity_FlyoutButton = "zUv9ab";
export let ribbonCustomizer_Button = "yULhsc";
export let insertLink_Button = "m7Zafc";
export let newNote_HeroButton = "Zj6qrd";
export let newNote_MenuButton = "W1MN9c";
export let signatureOptions_Button = "Pd7ZBb";
export let browseGroups_Button = "DH4EHb";
export let viewGroupsPanel_Button = "KZ9sNd";
export let viewGroupsPanel_Button_MLR = "cKdDAe";
export let addGroup_Button = "lCSn2d";
export let moreRetentionPoliciesOptions_Button = "oTeksd";
export let viewSettings_Button = "zyHYFd";
export let conversations_Button = "V79KWd";
export let messagePreview_Button = "UZvQqe";
export let layout_Button = "zLfWNc";
export let folder_Button = "fTNe2";
export let folderMenu_Show = "Hvb3Z";
export let folderMenu_Hide = "KO0O0";
export let density_Button = "HS1gU";
export let manageQuickSteps_Button = "KLHNYb";
export let messages_Button = "Bp9Ndd";
export let quickSteps_Button = "rPFClc";
export let quickSteps_MenuLauncherLabel = "g$f1ae";
export let markAllAsRead_Button = "B3IAcb";
export let draw_tab = "ahVQIc";
export let hide_Favorites = "ceK_$";
export let show_Favorites = "bEddH";
export let collapseConversation_Button = "VBo1Td";
export let expandConversation_Button = "IRjPKd";
export let zoom_Button = "UiGgzb";
export let ribbonMode_Button = "wJbLIc";
export let syncMailbox_Button = "mISjR";
export let mail_merge_tab = "UutzDc";
export default {home_tab,view_tab,message_tab,insert_tab,format_tab,options_tab,notes_tab,format_table_tab,format_picture_tab,newMessage_Button,newMessage_Button_MLR,newPost_Button,newPostHero_Button,newYammerPost_Button,newEMailMessage_Button,newCalEvent_Button,ignoreEmail_Button,stopIgnoringEmail_Button,blockSender_Button,notJunk_Button,archiveEmail_Button,sweepEmail_Button,replyToEmail_Button,replyAllToEmail_Button,replyForwardEmail_Button,replyForwardEmailAsAttachment_Button,replyMeetingToEmail_Button,replyCopilotMeetingToEmail_Button,replyCopilotMeetingToEmail_Button_Tooltip,readUnread_Button,pinUnpin_Button,pinUnpin_Button_MLR,sendAll_Button,updateFolder_Button,showSyncProgress_Button,cancelSync_Button,downloadHeaders_Button,move_FlyoutButton,move_FlyoutButton_MLR,rules_FlyoutButton,createRule_Button,manageRules_Button,assignPolicy_FlyoutButton,assignPolicy_FlyoutButton_MLR,categorize_FlyoutButton,sendReceiveGroups_Button,getMessageExtensions_Button,report_Button,immersiveReader_Button,remindersWindow_Button,printMail_Button,snooze_Button,undo_Button,block_Button,paste_FlyoutButton,formatPainter_Button,attachSig_Button,encrypt_clearPermissionsButton,sensitivity_FlyoutButton,ribbonCustomizer_Button,insertLink_Button,newNote_HeroButton,newNote_MenuButton,signatureOptions_Button,browseGroups_Button,viewGroupsPanel_Button,viewGroupsPanel_Button_MLR,addGroup_Button,moreRetentionPoliciesOptions_Button,viewSettings_Button,conversations_Button,messagePreview_Button,layout_Button,folder_Button,folderMenu_Show,folderMenu_Hide,density_Button,manageQuickSteps_Button,messages_Button,quickSteps_Button,quickSteps_MenuLauncherLabel,markAllAsRead_Button,draw_tab,hide_Favorites,show_Favorites,collapseConversation_Button,expandConversation_Button,zoom_Button,ribbonMode_Button,syncMailbox_Button,mail_merge_tab};